export const DEFAULT_DTM_DATA = {
    spa: true,
    pillar: "feed",
    preventDefault: true,
};
export const DTM_WINDOW_PATH = "CBC.APP.SC.DTM";
export const MAX_LIMIT_THRESHOLD = 3000;
export const INTERVAL_LENGTH = 200;
export const TRACKING_LIMIT_REACHED = "Tracking limit reached";
